const BANNER_WIDTH = 2400;
const BANNER_HEIGHT = 800;
const BANNER_QUALITY = 85;

function isOptimizableUrl(url) {
  if (!url) return false;
  if (url.startsWith("data:") || url.startsWith("blob:")) return false;
  if (url.includes("wsrv.nl") || url.includes("images.weserv.nl")) return false;
  return /^https?:\/\//i.test(url);
}

function buildOptimizedBannerUrl(url, fit) {
  const src = url?.trim();
  if (!src) return null;

  if (process.env.REACT_APP_BANNER_IMAGE_OPTIMIZER === "false") {
    return src;
  }

  if (!isOptimizableUrl(src)) {
    return src;
  }

  const encoded = encodeURIComponent(src);
  return `https://wsrv.nl/?url=${encoded}&w=${BANNER_WIDTH}&h=${BANNER_HEIGHT}&fit=${fit}&q=${BANNER_QUALITY}&output=webp&n=-1`;
}

/**
 * Banner images — cover fit for homepage hero carousel.
 */
export function optimizeBannerImageUrl(url) {
  return buildOptimizedBannerUrl(url, "cover");
}

/** Inner page banners — preserve full graphic (no crop). */
export function optimizePageBannerImageUrl(url) {
  return buildOptimizedBannerUrl(url, "inside");
}

export function optimizeBannerImages(banners) {
  return (banners || []).map((banner) => {
    if (!banner?.image) return banner;
    return {
      ...banner,
      image: optimizeBannerImageUrl(banner.image) || banner.image,
    };
  });
}
